import * as api from '../../api/equityFinder/property';
import { makeApiActionCreatorV3 } from '../utils';

export const PROPERTY_FETCH_SEARCH_OPTIONS_START =
  'PROPERTY/PROPERTY_FETCH_SEARCH_OPTIONS_START';
export const PROPERTY_FETCH_SEARCH_OPTIONS_SUCCESS =
  'PROPERTY/PROPERTY_FETCH_SEARCH_OPTIONS_SUCCESS';
export const PROPERTY_FETCH_SEARCH_OPTIONS_ERROR =
  'PROPERTY/PROPERTY_FETCH_SEARCH_OPTIONS_ERROR';

export const PROPERTY_FETCH_SEARCH_RULES_START =
  'PROPERTY/PROPERTY_FETCH_SEARCH_RULES_START';
export const PROPERTY_FETCH_SEARCH_RULES_SUCCESS =
  'PROPERTY/PROPERTY_FETCH_SEARCH_RULES_SUCCESS';
export const PROPERTY_FETCH_SEARCH_RULES_ERROR =
  'PROPERTY/PROPERTY_FETCH_SEARCH_RULES_ERROR';

export const PROPERTY_FETCH_FIELDS_START =
  'PROPERTY/PROPERTY_FETCH_FIELDS_START';
export const PROPERTY_FETCH_FIELDS_SUCCESS =
  'PROPERTY/PROPERTY_FETCH_FIELDS_SUCCESS';
export const PROPERTY_FETCH_FIELDS_ERROR =
  'PROPERTY/PROPERTY_FETCH_FIELDS_ERROR';

export const PROPERTY_SEARCH_START = 'PROPERTY/PROPERTY_SEARCH_START';
export const PROPERTY_SEARCH_SUCCESS = 'PROPERTY/PROPERTY_SEARCH_SUCCESS';
export const PROPERTY_SEARCH_ERROR = 'PROPERTY/PROPERTY_SEARCH_ERROR';

export const ALL_PROPERTY_FETCH_START = 'PROPERTY/ALL_PROPERTY_FETCH_START';
export const ALL_PROPERTY_FETCH_SUCCESS = 'PROPERTY/ALL_PROPERTY_FETCH_SUCCESS';
export const ALL_PROPERTY_FETCH_ERROR = 'PROPERTY/ALL_PROPERTY_FETCH_ERROR';

export const PROPERTY_FETCH_START = 'PROPERTY/PROPERTY_FETCH_START';
export const PROPERTY_FETCH_SUCCESS = 'PROPERTY/PROPERTY_FETCH_SUCCESS';
export const PROPERTY_FETCH_ERROR = 'PROPERTY/PROPERTY_FETCH_ERROR';

export const PROTEST_FETCH_START = 'PROPERTY/PROTEST_FETCH_START';
export const PROTEST_FETCH_SUCCESS = 'PROPERTY/PROTEST_FETCH_SUCCESS';
export const PROTEST_FETCH_ERROR = 'PROPERTY/PROTEST_FETCH_ERROR';

export const PROPERTY_CHANGE_CURRENT_PAGE =
  'PROPERTY/PROPERTY_CHANGE_CURRENT_PAGE';
export const PROPERTY_CHANGE_SORT_MODEL = 'PROPERTY/PROPERTY_CHANGE_SORT_MODEL';
export const PROPERTY_CHANGE_FILTER_MODEL =
  'PROPERTY/PROPERTY_CHANGE_FILTER_MODEL';
export const PROPERTY_CHANGE_PAGE_SIZE = 'PROPERTY/PROPERTY_CHANGE_PAGE_SIZE';
export const PROPERTY_SET_SEARCH_RULE = 'PROPERTY/PROPERTY_SET_SEARCH_RULE';
export const PROPERTY_REMOVE_SEARCH_RULE =
  'PROPERTY/PROPERTY_REMOVE_SEARCH_RULE';
export const PROPERTY_REMOVE_ALL_SEARCH_RULE =
  'PROPERTY/PROPERTY_REMOVE_ALL_SEARCH_RULE';
export const PROPERTY_CHANGE_SEARCH_FIELD =
  'PROPERTY/PROPERTY_CHANGE_SEARCH_FIELD';
export const PROPERTY_CHANGE_SEARCH_OPERATOR =
  'PROPERTY/PROPERTY_CHANGE_SEARCH_OPERATOR';

export const COMP_SCORE_FETCH_START = 'PROPERTY/COMP_SCORE_FETCH_START';
export const COMP_SCORE_FETCH_SUCCESS = 'PROPERTY/COMP_SCORE_FETCH_SUCCESS';
export const COMP_SCORE_FETCH_ERROR = 'PROPERTY/COMP_SCORE_FETCH_ERROR';

export const PROPERTY_COMP_GRID_FETCH_START =
  'PROPERTY/PROPERTY_COMP_GRID_FETCH_START';
export const PROPERTY_COMP_GRID_FETCH_SUCCESS =
  'PROPERTY/PROPERTY_COMP_GRID_FETCH_SUCCESS';
export const PROPERTY_COMP_GRID_FETCH_ERROR =
  'PROPERTY/PROPERTY_COMP_GRID_FETCH_ERROR';

export const PROPERTY_CATEGORIES_FETCH_START =
  'PROPERTY/PROPERTY_CATEGORIES_FETCH_START';
export const PROPERTY_CATEGORIES_FETCH_SUCCESS =
  'PROPERTY/PROPERTY_CATEGORIES_FETCH_SUCCESS';
export const PROPERTY_CATEGORIES_FETCH_ERROR =
  'PROPERTY/PROPERTY_CATEGORIES_FETCH_ERROR';

export const PROPERTY_CATEGORY_FETCH_START =
  'PROPERTY/PROPERTY_CATEGORY_FETCH_START';
export const PROPERTY_CATEGORY_FETCH_SUCCESS =
  'PROPERTY/PROPERTY_CATEGORY_FETCH_SUCCESS';
export const PROPERTY_CATEGORY_FETCH_ERROR =
  'PROPERTY/PROPERTY_CATEGORY_FETCH_ERROR';

export const PROPERTY_COMP_SEARCH_START = 'PROPERTY/PROPERTY_COMP_SEARCH_START';
export const PROPERTY_COMP_SEARCH_SUCCESS =
  'PROPERTY/PROPERTY_COMP_SEARCH_SUCCESS';
export const PROPERTY_COMP_SEARCH_ERROR = 'PROPERTY/PROPERTY_COMP_SEARCH_ERROR';

export const PROPERTY_COMP_VALID_CHECK_START =
  'PROPERTY/PROPERTY_COMP_VALID_CHECK_START';
export const PROPERTY_COMP_VALID_CHECK_SUCCESS =
  'PROPERTY/PROPERTY_COMP_VALID_CHECK_SUCCESS';
export const PROPERTY_COMP_VALID_CHECK_ERROR =
  'PROPERTY/PROPERTY_COMP_VALID_CHECK_ERROR';

export const PROPERTY_COMP_PDF_GENERATE_START =
  'PROPERTY/PROPERTY_COMP_PDF_GENERATE_START';
export const PROPERTY_COMP_PDF_GENERATE_SUCCESS =
  'PROPERTY/PROPERTY_COMP_PDF_GENERATE_SUCCESS';
export const PROPERTY_COMP_PDF_GENERATE_ERROR =
  'PROPERTY/PROPERTY_COMP_PDF_GENERATE_ERROR';

export const PROPERTY_COVER_PDF_GENERATE_START =
  'PROPERTY/PROPERTY_COVER_PDF_GENERATE_START';
export const PROPERTY_COVER_PDF_GENERATE_SUCCESS =
  'PROPERTY/PROPERTY_COVER_PDF_GENERATE_SUCCESS';
export const PROPERTY_COVER_PDF_GENERATE_ERROR =
  'PROPERTY/PROPERTY_COVER_PDF_GENERATE_ERROR';

export const PROPERTY_SCORE_FETCH_START = 'PROPERTY/PROPERTY_SCORE_FETCH_START';
export const PROPERTY_SCORE_FETCH_SUCCESS =
  'PROPERTY/PROPERTY_SCORE_FETCH_SUCCESS';
export const PROPERTY_SCORE_FETCH_ERROR = 'PROPERTY/PROPERTY_SCORE_FETCH_ERROR';

export const VERSION_COMPS_REORDER_START =
  'PROPERTY/VERSION_COMPS_REORDER_START';
export const VERSION_COMPS_REORDER_SUCCESS =
  'PROPERTY/VERSION_COMPS_REORDER_SUCCESS';
export const VERSION_COMPS_REORDER_ERROR =
  'PROPERTY/VERSION_COMPS_REORDER_ERROR';

export const INTEGRITY_CHECK_START = `PROPERTY/INTEGRITY_CHECK_START`;
export const INTEGRITY_CHECK_SUCCESS = `PROPERTY/INTEGRITY_CHECK_SUCCESS`;
export const INTEGRITY_CHECK_ERROR = `PROPERTY/INTEGRITY_CHECK_ERROR`;

export const GENERATE_GOOGLE_MAP_START = 'PROPERTY/GENERATE_GOOGLE_MAP_START';
export const GENERATE_GOOGLE_MAP_SUCCESS =
  'PROPERTY/GENERATE_GOOGLE_MAP_SUCCESS';
export const GENERATE_GOOGLE_MAP_ERROR = 'PROPERTY/GENERATE_GOOGLE_MAP_ERROR';

export const GENERATE_BING_MAP_START = 'PROPERTY/GENERATE_BING_MAP_START';
export const GENERATE_BING_MAP_SUCCESS = 'PROPERTY/GENERATE_BING_MAP_SUCCESS';
export const GENERATE_BING_MAP_ERROR = 'PROPERTY/GENERATE_BING_MAP_ERROR';

export const PROPERTY_SCORE_UNSET = 'PROPERTY/PROPERTY_SCORE_UNSET';

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  PROPERTY_FETCH_SEARCH_OPTIONS_START,
  PROPERTY_FETCH_SEARCH_OPTIONS_SUCCESS,
  PROPERTY_FETCH_SEARCH_OPTIONS_ERROR,
);
export const fetchSearchRules = makeApiActionCreatorV3(
  api.fetchSearchRules,
  PROPERTY_FETCH_SEARCH_RULES_START,
  PROPERTY_FETCH_SEARCH_RULES_SUCCESS,
  PROPERTY_FETCH_SEARCH_RULES_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  PROPERTY_FETCH_FIELDS_START,
  PROPERTY_FETCH_FIELDS_SUCCESS,
  PROPERTY_FETCH_FIELDS_ERROR,
);
export const fetchProperty = makeApiActionCreatorV3(
  api.fetchProperty,
  PROPERTY_FETCH_START,
  PROPERTY_FETCH_SUCCESS,
  PROPERTY_FETCH_ERROR,
);
export const fetchProtest = makeApiActionCreatorV3(
  api.fetchProtest,
  PROTEST_FETCH_START,
  PROTEST_FETCH_SUCCESS,
  PROTEST_FETCH_ERROR,
);
export const searchProperty = makeApiActionCreatorV3(
  api.searchProperty,
  PROPERTY_SEARCH_START,
  PROPERTY_SEARCH_SUCCESS,
  PROPERTY_SEARCH_ERROR,
);
export const fetchAllProperty = makeApiActionCreatorV3(
  api.fetchAllProperty,
  ALL_PROPERTY_FETCH_START,
  ALL_PROPERTY_FETCH_SUCCESS,
  ALL_PROPERTY_FETCH_ERROR,
);
export const fetchCompScore = makeApiActionCreatorV3(
  api.fetchCompScore,
  COMP_SCORE_FETCH_START,
  COMP_SCORE_FETCH_SUCCESS,
  COMP_SCORE_FETCH_ERROR,
);
export const fetchCompGrid = makeApiActionCreatorV3(
  api.fetchCompGrid,
  PROPERTY_COMP_GRID_FETCH_START,
  PROPERTY_COMP_GRID_FETCH_SUCCESS,
  PROPERTY_COMP_GRID_FETCH_ERROR,
);
export const fetchPropertyCategories = makeApiActionCreatorV3(
  api.fetchPropertyCategories,
  PROPERTY_CATEGORIES_FETCH_START,
  PROPERTY_CATEGORIES_FETCH_SUCCESS,
  PROPERTY_CATEGORIES_FETCH_ERROR,
);
export const fetchPropertyCategory = makeApiActionCreatorV3(
  api.fetchPropertyCategory,
  PROPERTY_CATEGORY_FETCH_START,
  PROPERTY_CATEGORY_FETCH_SUCCESS,
  PROPERTY_CATEGORY_FETCH_ERROR,
);
export const searchPropertyComp = makeApiActionCreatorV3(
  api.searchPropertyComp,
  PROPERTY_COMP_SEARCH_START,
  PROPERTY_COMP_SEARCH_SUCCESS,
  PROPERTY_COMP_SEARCH_ERROR,
);
export const checkValidPropertyComp = makeApiActionCreatorV3(
  api.checkValidPropertyComp,
  PROPERTY_COMP_VALID_CHECK_START,
  PROPERTY_COMP_VALID_CHECK_SUCCESS,
  PROPERTY_COMP_VALID_CHECK_ERROR,
);
export const generateCompPDF = makeApiActionCreatorV3(
  api.generateCompPDF,
  PROPERTY_COMP_PDF_GENERATE_START,
  PROPERTY_COMP_PDF_GENERATE_SUCCESS,
  PROPERTY_COMP_PDF_GENERATE_ERROR,
);
export const generateCoverPDF = makeApiActionCreatorV3(
  api.generateCoverPDF,
  PROPERTY_COVER_PDF_GENERATE_START,
  PROPERTY_COVER_PDF_GENERATE_SUCCESS,
  PROPERTY_COVER_PDF_GENERATE_ERROR,
);
export const fetchPropertyScore = makeApiActionCreatorV3(
  api.fetchPropertyScore,
  PROPERTY_SCORE_FETCH_START,
  PROPERTY_SCORE_FETCH_SUCCESS,
  PROPERTY_SCORE_FETCH_ERROR,
);
export const reorderVersionComps = makeApiActionCreatorV3(
  api.reorderVersionComps,
  VERSION_COMPS_REORDER_START,
  VERSION_COMPS_REORDER_SUCCESS,
  VERSION_COMPS_REORDER_ERROR,
);

export const integrityCheck = makeApiActionCreatorV3(
  api.integrityCheck,
  INTEGRITY_CHECK_START,
  INTEGRITY_CHECK_SUCCESS,
  INTEGRITY_CHECK_ERROR,
);

export const generateGoogleMap = makeApiActionCreatorV3(
  api.generateGoogleMap,
  GENERATE_GOOGLE_MAP_START,
  GENERATE_GOOGLE_MAP_SUCCESS,
  GENERATE_GOOGLE_MAP_ERROR,
);

export const generateBingMap = makeApiActionCreatorV3(
  api.generateBingMap,
  GENERATE_BING_MAP_START,
  GENERATE_BING_MAP_SUCCESS,
  GENERATE_BING_MAP_ERROR,
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_SORT_MODEL, data: model });
  };
}

export function changeFilterModel(model) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_FILTER_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_PAGE_SIZE, data: page });
  };
}

export function setRule(ruleName, ruleValue) {
  return async dispatch => {
    dispatch({ type: PROPERTY_SET_SEARCH_RULE, data: { ruleName, ruleValue } });
  };
}

export function changeSearchField(searchField) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_SEARCH_FIELD, data: searchField });
  };
}

export function changeSearchOperator(searchOperator) {
  return async dispatch => {
    dispatch({ type: PROPERTY_CHANGE_SEARCH_OPERATOR, data: searchOperator });
  };
}

export function removeRule(ruleName) {
  return async dispatch => {
    dispatch({ type: PROPERTY_REMOVE_SEARCH_RULE, data: { ruleName } });
  };
}

export function removeAllRule() {
  return async dispatch => {
    dispatch({ type: PROPERTY_REMOVE_ALL_SEARCH_RULE });
  };
}

export function unsetProdigyScore() {
  return async dispatch => {
    dispatch({ type: PROPERTY_SCORE_UNSET });
  };
}
